import { fontDisplay, lineHeightToFontSize } from 'common-react';
import {
  createStyles,
  makeStyles,
  Theme,
  ThemeColorsModel,
  ThemeFontSizeModel,
} from 'ui-components';

const CONTENT_MAX_WIDTH = 550;
const STEP_NUMBER_SIZE = 32;
const STEP_PADDING_VER = 16;

export default makeStyles((theme: Theme & {
  color: ThemeColorsModel;
  fontFamily: {
    ingMeWebBold: string;
  };
  fontSize: ThemeFontSizeModel;
}) => createStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    minWidth: 0,
  },

  card: {
    boxShadow: `inset 0 0 0 1px ${theme.color.greys[15]}`,
    padding: 40,

    [theme.breakpoints.down('sm')]: {
      padding: 24,
    },

    [theme.breakpoints.down('xs')]: {
      padding: 16,
    },
  },

  resultCard: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'space-between',
    gap: 16,
  },

  resultValue: {
    textAlign: 'right',
    whiteSpace: 'nowrap',
  },

  stepsCard: {
    display: 'flex',
    justifyContent: 'center',

    [theme.breakpoints.down('xs')]: {
      padding: '24px 16px',
    },
  },

  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
    maxWidth: CONTENT_MAX_WIDTH,
  },

  badge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
    margin: 0,
    padding: '2px 8px',
    borderRadius: 4,
    backgroundColor: theme.color.blues[10],
  },

  badgeIcon: {
    width: 16,
    height: 16,
    flexShrink: 0,
  },

  title: {
    padding: '8px 0 16px',
  },

  stepList: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    margin: 0,
    padding: 0,
    listStyle: 'none',
  },

  step: {
    position: 'relative',
    display: 'flex',
    alignItems: 'flex-start',
    gap: 16,
    padding: `${STEP_PADDING_VER}px 0`,

    '&:last-child': {
      paddingBottom: 32,
    },

    '&:not(:last-child)::before': {
      content: '""',
      position: 'absolute',
      left: (STEP_NUMBER_SIZE - 1) / 2,
      top: STEP_PADDING_VER + STEP_NUMBER_SIZE,
      bottom: -STEP_PADDING_VER,
      width: 1,
      backgroundColor: theme.color.greys[20],
    },
  },

  stepNumber: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    width: STEP_NUMBER_SIZE,
    height: STEP_NUMBER_SIZE,
    borderRadius: 8,
    backgroundColor: theme.color.greys[15],
    color: theme.color.greys[40],
    font: fontDisplay('normal', theme.fontSize.base, lineHeightToFontSize.base),
  },

  stepNumberCurrent: {
    backgroundColor: theme.color.maroons[150],
    color: theme.color.greys[0],
  },

  stepText: {
    paddingTop: 4,
  },

  stepAccent: {
    fontFamily: theme.fontFamily.ingMeWebBold,
    fontWeight: 700,
  },

  divider: {
    width: '100%',
    margin: 0,
  },

  privacyNote: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 12,
    margin: 0,
    paddingTop: 16,
  },

  privacyIcon: {
    width: 20,
    height: 20,
    flexShrink: 0,
    color: theme.color.oranges[50],
  },
}), { name: 'RetirementCalculatorPreview' });
